import React from 'react';
import { SxStyle } from '../../types';
import Box from '@mui/material/Box';
import Image from './image';
import PersonIcon from '@mui/icons-material/Person';
import { Typography } from '@mui/material';

const styles: SxStyle = {
  container: {
    position: 'relative',
    height: 64, // Topbar height from app
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    borderBottom: '1px solid',
  },
  image: {
    position: 'absolute',
    top: 20,
    height: 64,
  },
  text: {
    position: 'absolute',
    top: 22,
    left: 30,
  },
  icon: {
    position: 'absolute',
    top: 20,
    right: 20,
  },
};

interface Props {
  teamName?: string;
  logoImageUrl?: string;
  backgroundColor: string;
  foregroundColor: string;
  borderColor: string;
}

const PreviewTopBar = ({
  teamName,
  logoImageUrl,
  backgroundColor,
  foregroundColor,
  borderColor,
}: Props) => {
  return (
    <Box
      sx={{
        ...styles.container,
        ...{ backgroundColor: backgroundColor, borderBottomColor: borderColor },
      }}
    >
      {teamName && (
        <Typography sx={{ ...styles.text, ...{ color: foregroundColor } }} variant="body1-bold">
          {teamName}
        </Typography>
      )}
      {logoImageUrl && <Image src={logoImageUrl} alt="Team logo" sx={styles.image} />}
      <PersonIcon sx={{ ...styles.icon, ...{ color: foregroundColor } }} />
    </Box>
  );
};

export default PreviewTopBar;
